import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { ChatBatchResult } from '../ChatBatchResult'

// Declared here so the batch menu's seventh entry has its input shape; the Action that
// consumes it lands separately, which keeps this args class off the schema until then.
@InputType()
export class BatchMarkChatsAsSpamArgs extends ActionArgs {
  @Field(() => [ID])
  chatIds: string[]
}

export interface IBatchMarkChatsAsSpam extends IAction<ChatBatchResult, BatchMarkChatsAsSpamArgs> {}
